import {
    KeyboardArrowLeft,
    KeyboardArrowRight,
    KeyboardDoubleArrowLeft,
    KeyboardDoubleArrowRight,
} from '@mui/icons-material'
import { IconButton, Typography } from '@mui/material'
import { Box } from '@mui/system'
import moment from 'moment'

const CustomMonthPicker = ({ date, setDate }) => {
    const start = date?.start ? moment(date.start) : moment();
    const end = date?.end ? moment(date.end) : moment().add(1, 'year');

    const maxDate = moment()

    return (
        <Box
            sx={{
                display: 'flex',
                padding: 2,
                justifyContent: 'space-around',
                alignItems: 'center',
            }}
        >
            <IconButton
                onClick={() =>
                    setDate({
                        start: start.clone().subtract(1, 'year'),
                        end: end.clone().subtract(1, 'year'),
                    })
                }
            >
                <KeyboardDoubleArrowLeft color="primary" />
            </IconButton>

            <IconButton
                onClick={() =>
                    setDate({
                        start: start.clone().subtract(1, 'month'),
                        end: end.clone().subtract(1, 'month'),
                    })
                }
            >
                <KeyboardArrowLeft color="primary" />
            </IconButton>

            <Typography
                sx={{
                    display: "flex",
                    fontFamily: "Public Sans",
                    fontWeight: "bold",
                    color: "#1D013B"
                }}
                variant="body1"
            >
                {`${start.format('MMM YYYY')} – ${end.format('MMM YYYY')}`}
            </Typography>

            <IconButton
                onClick={() =>
                    setDate({
                        start: start.clone().add(1, 'month'),
                        end: end.clone().add(1, 'month'),
                    })
                }
                disabled={end.clone().add(1, 'month').isAfter(maxDate)}
            >
                <KeyboardArrowRight
                    color={end.clone().add(1, 'month').isAfter(maxDate) ? "disabled" : "primary"}
                />
            </IconButton>

            <IconButton
                onClick={() =>
                    setDate({
                        start: start.clone().add(1, 'year'),
                        end: end.clone().add(1, 'year'),
                    })
                }
                disabled={end.clone().add(1, 'year').isAfter(maxDate)}
            >
                <KeyboardDoubleArrowRight
                    color={end.clone().add(1, 'year').isAfter(maxDate) ? "disabled" : "primary"}
                />
            </IconButton>
        </Box>
    )
}

export default CustomMonthPicker
